import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

import * as Cookies from 'js-cookie';

const classes = {
	selectLink: 'js-m-market-switch__switch',
};

@createModule('MarketSwitch')
/**
 * market-switch module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class MarketSwitch extends TerrificSpec {
	start(resolve: Function) {
		const $select = this._getLanguageSelect();
		const cachedCountry = Cookies.get('cov_market');
		const baseUrl = $select.data('baseUrl');
		const preventAutoSubmit = $(this._ctx).attr('data-preventautosubmit');
		this._updateSelectedOption($select, cachedCountry);

		$select.on('change', (ev: Event) => this.followOptionLink(ev, baseUrl, preventAutoSubmit == 'true'));
		resolve();
	}
	stop() {}
	/**
	 * returns DOM Element
	 */
	_getLanguageSelect(): JQuery {
		return $(this._ctx).find(`.${classes.selectLink}`);
	}

	/**
	 * update selected option of given select element if it is not already selected
	 *
	 * @param $select | jQuery Element tag select
	 * @param value  | value of select option
	 */
	_updateSelectedOption($select: JQuery, value: string) {
		if (value && $select.val() !== value && $(`option[value="${value}"]`, $select).length > 0) {
			$select.val(value);
		}
	}
	/**
	 * follow link of selected option on change
	 *
	 * @param $select | jQuery Element tag select
	 * @param ev  | value of select option
	 */
	followOptionLink(ev: any, baseUrl: string, preventAutoSubmit: boolean) {
		let market = ev.currentTarget.value;
		Cookies.set('cov_market', market);
		if (preventAutoSubmit === false) {
			window.location.href = baseUrl + market;
		}
	}
}
